/*
 * Copyright (c) 2020 NOOGA DEVELOPMENT, All rights reserved.
 * Author Raman Kremko <raman.kremko@noogadev.com>
 */

import {
    RegistryItemsCountDto,
    PaymentTypesStatDto,
    TurnoversByActivitiesDto,
    TurnoversByActivitiesByCategories,
} from '../api/dashBoard/dashBoardClient.typings';
import { DashBoardFinAction, DashBoardFinActionType } from '../actions/dashBoardFinActions';
import { FinChartsFilesMap } from '../../components/Charts/Common/ChartsTyping';
import { StoreCategory } from '../api/stores/storesClientTypings';
import { Order } from '../api/apiCommon.typings';

export const TURNOVERS_FIRST_CATEGORY = StoreCategory.TRADE;
export const TURNOVERS_SECOND_CATEGORY = StoreCategory.GAS_STATION;
export const TURNOVERS_LIMIT = 5;
export const DEFAULT_SORTING_KEY: keyof TurnoversByActivitiesDto = 'turnover';
export const DEFAULT_SORTING_ORDER: Order = 'asc';

export interface DashBoardFinState {
    paymentTypes: PaymentTypesStatDto[];
    turnoversByActivities: TurnoversByActivitiesByCategories;
    registryItemsCountInfo: RegistryItemsCountDto;

    isLoadingPaymentTypes: boolean;
    isLoadingTurnoversByActivities: boolean;
    isLoadingRegistryItemsCountInfo: boolean;
}

const initialState: DashBoardFinState = {
    paymentTypes: [],
    turnoversByActivities: {
        firstCategory: [],
        secondCategory: [],
        other: [],
    },
    registryItemsCountInfo: null,

    isLoadingPaymentTypes: false,
    isLoadingTurnoversByActivities: false,
    isLoadingRegistryItemsCountInfo: false,
};

export function dashBoardFinReducer(
    state: DashBoardFinState = initialState,
    action: DashBoardFinAction,
): DashBoardFinState {
    let newState: DashBoardFinState;
    switch (action.type) {
        case DashBoardFinActionType.OPEN_DASHBOARD_FIN_PAGE:
            return {
                ...state,
                isLoadingPaymentTypes: true,
                isLoadingTurnoversByActivities: true,
                isLoadingRegistryItemsCountInfo: true,
            };

        case DashBoardFinActionType.FETCH_PAYMENT_TYPES_SUCCESS:
            return {
                ...state,
                paymentTypes: action.payload,
                isLoadingPaymentTypes: false,
            };

        case DashBoardFinActionType.FETCH_PAYMENT_TYPES_ERROR:
            return {
                ...state,
                isLoadingPaymentTypes: false,
            };

        case DashBoardFinActionType.FETCH_TURNOVERS_BY_ACTIVITIES_SUCCESS:
            return {
                ...state,
                turnoversByActivities: action.payload,
                isLoadingTurnoversByActivities: false,
            };

        case DashBoardFinActionType.FETCH_TURNOVERS_BY_ACTIVITIES_ERROR:
            return {
                ...state,
                isLoadingTurnoversByActivities: false,
            };

        case DashBoardFinActionType.FETCH_REGISTRY_ITEMS_COUNT_INFO_SUCCESS:
            return {
                ...state,
                registryItemsCountInfo: action.payload,
                isLoadingRegistryItemsCountInfo: false,
            };

        case DashBoardFinActionType.FETCH_REGISTRY_ITEMS_COUNT_INFO_ERROR:
            return {
                ...state,
                isLoadingRegistryItemsCountInfo: false,
            };

        case DashBoardFinActionType.DOWNLOAD_EXCEL:
            newState = { ...state };
            newState[FinChartsFilesMap[action.payload.dataType].isLoadingKey] = true;
            return newState;

        case DashBoardFinActionType.DOWNLOAD_EXCEL_SUCCESS:
            newState = { ...state };
            newState[FinChartsFilesMap[action.payload].isLoadingKey] = false;
            return newState;

        case DashBoardFinActionType.DOWNLOAD_EXCEL_ERROR:
            newState = { ...state };
            newState[FinChartsFilesMap[action.payload.dataType].isLoadingKey] = false;
            return newState;

        case DashBoardFinActionType.EXIT_DASHBOARD_FIN_PAGE:
            return {
                ...initialState,
            };
    }

    return state;
}
